import initialState from './initialState';
import {SHOW_SUCCESS, SHOW_FAILURE, AUTH_SUCCESS, AUTH_FAILURE, LOGOUT_SUCCESS, TOKEN_SUCCESS, CURRENT_NODE_INFO,
       TOKEN_FAILURE, GET_TOKEN_SUCCESS, GET_TOKEN_FAILURE,GET_NODE_DATA_SUCCESS,GET_NODE_DATA_FAILURE, HIDE_ALERTS,
       EMAIL_RESET_SENT, EMAIL_RESET_FAIL}
 from '../actions/actionTypes';

export default function stuff(state = initialState.initState, action) {
    
  // let newState;
  switch (action.type) {
   case HIDE_ALERTS:
   return Object.assign({}, state, {bugReportSuccess:null, addUserSuccess:null,editNodeSuccess:null, mapNodeInfoSuccess:null, mapNodeInfoData:null, addNodeSuccess:null, editUserSuccess:null, userInfoSuccess:null, userInfoData:null, changeSleepSuccess:null, sleepInfoSuccess:null, sleepInfoData:null, emailSuccess:null, showSuccessAlert:false,showFailureAlert:false,showTokenFailureAlert:false,showTokenSuccessAlert:false, getTokenSuccessAlert:false,  getTokenFailureAlert:false,getNodeDataSuccessAlert:false, getNodeDataFailureAlert:false, nodeInfoData:null, nodeInfoSuccess:null})
    case SHOW_SUCCESS:
      return Object.assign({}, state, {showSuccessAlert:true, authenticated:true})
    case SHOW_FAILURE:
    return Object.assign({}, state, {showSuccessAlert:false, showFailureAlert:true, authenticated:false, errMsg:action.data})
    case AUTH_SUCCESS:
      return Object.assign({}, state, {authenticated:true, userName:action.data.userName, userId:action.data.id, userEmail:action.data.userEmail, showSuccessAlert:true})
    case LOGOUT_SUCCESS:
      return Object.assign({}, state, {
        email: null,
        password: null,
        initName:null,
        userName :'Log In',
        id:null,
        error:null,
        authenticated:false,
        agreedTerms: null,
        showError:null,})
    case AUTH_FAILURE:
      return Object.assign({}, state, {authenticated:false})
    case TOKEN_SUCCESS:
      return Object.assign({}, state, {showTokenSuccessAlert:true,  showTokenFailureAlert:false, token:action.data})
    case TOKEN_FAILURE:
      return Object.assign({}, state, {showTokenSuccessAlert:false, showTokenFailureAlert:true, errMsg:action.data})
    case GET_TOKEN_SUCCESS:
      return Object.assign({}, state, {getTokenSuccessAlert:true,  getTokenFailureAlert:false, tokens:action.data})
    case GET_TOKEN_FAILURE:
      return Object.assign({}, state, {getTokenSuccessAlert:false, getTokenFailureAlert:true,  tokens:action.data})
    case GET_NODE_DATA_SUCCESS:
      return Object.assign({}, state, { isFetching:false, getNodeDataSuccessAlert:true,  getNodeDataFailureAlert:false, nodeData:action.data})
    case GET_NODE_DATA_FAILURE:
      return Object.assign({}, state, {isFetching:false, getNodeDataSuccessAlert:false, getNodeDataFailureAlert:true,  nodeData:action.data});
    case "GET_NODE_GRAPH_DATA_SUCCESS":
      return Object.assign({}, state, {getNodeGraphDataSuccessAlert:true,  getNodeGraphDataFailureAlert:false, graphNodeData:action.data.data})
    case "GET_NODE_GRAPH_DATA_FAILURE":
      return Object.assign({}, state, {getNodeGraphDataSuccessAlert:false, getNodeGraphDataFailureAlert:true,  graphNodeData:action.data});
    case CURRENT_NODE_INFO:
      return Object.assign({}, state, {currentNode:action.node, currentLimit:action.limit, currentFromDate:action.fromDate, currentToDate:action.toDate});
    case "NODE_INFO_SUCCESS":
        return{...state, nodeInfoSuccess:true, nodeInfoData:action.data}
    case "MAP_NODE_INFO_SUCCESS":
        return {...state, mapNodeInfoSuccess:true, mapNodeInfoData:action.data}
    case "ADD_NODE_SUCCESS":
        return{...state, addNodeSuccess:true}
    case "ADD_NODE_FAILURE":
        return{...state, addNodeSuccess:false}
    case "EDIT_NODE_SUCCESS": 
        return{...state, editNodeSuccess:true}
    case "EDIT_NODE_FAILURE":
        return {...state, editNodeSuccess:false}
    case "NODE_INFO_FAILURE":
        return {...state, nodeInfoSuccess:false}
    case "SLEEP_INFO_SUCCESS":
        return{...state, sleepInfoSuccess:true, sleepInfoData:action.data}
    case "SLEEP_INFO_FAILURE":
        return{...state, sleepInfoSuccess:false}
    case  "CHANGE_SLEEP_SUCCESS":
        return {...state, changeSleepSuccess:true}
    case  "CHANGE_SLEEP_FAILURE":
        return {...state, changeSleepSuccess:false}
    case EMAIL_RESET_SENT:
        return Object.assign({}, state, {emailSuccess:true})
    case EMAIL_RESET_FAIL:
      return Object.assign({}, state, {emailSuccess:false})
    case "USER_INFO_SUCCESS":
        return Object.assign({}, state, {userInfoSuccess:true, userInfoData:action.data})
    case "USER_INFO_FAILURE":
        return Object.assign({}, state, {userInfoSuccess:false, userInfoData:action.data})
    case "ADD_USER_SUCCESS":
        return Object.assign({}, state, {addUserSuccess:true})
    case "ADD_USER_FAILURE":
        return Object.assign({}, state, {addUserSuccess:false})
    case "EDIT_USER_SUCCESS":
        return Object.assign({}, state, {editUserSuccess:true})
    case "EDIT_USER_FAILURE":
        return Object.assign({}, state, {editUserSuccess:false})
    case "BUG_REPORT_FAILURE":
        return {...state, bugReportSuccess:false}
    case "BUG_REPORT_SUCCESS":
        return {...state, bugReportSuccess:true}
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/stuffReducer.js